import { theme as antdTheme } from 'antd';

const palette = {
  black100: '#0A0A0A',
  black2: '#0E0E0C',
  black3: '#0E0E0E',
  white100: '#EFEFEF',
  gray100: '#4A4A4A',
  gray2: '#3E3E3E',
  green100: '#7C9178',
  darkGreen: '#181F17',
  darkRed: '#130F0E',
  red100: '#966463',
};

const fontFamily = "'IBM Plex Mono', ui-monospace, 'SFMono-Regular', Menlo, monospace";

export const limitekTheme = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: palette.green100,
    colorInfo: palette.green100,
    colorSuccess: palette.green100,
    colorError: palette.red100,
    colorLink: palette.green100,
    colorLinkHover: palette.green100,

    colorBgBase: palette.black100,
    colorBgLayout: palette.black100,
    colorBgContainer: palette.black2,
    colorBgElevated: palette.black2,

    colorBorder: palette.gray2,
    colorBorderSecondary: palette.gray2,

    colorText: palette.white100,
    colorTextSecondary: palette.gray100,
    colorTextTertiary: palette.gray100,
    colorTextPlaceholder: palette.gray100,

    fontFamily,
    fontSize: 16,
    borderRadius: 6,
    borderRadiusLG: 6,
    borderRadiusSM: 6,
    wireframe: false,
  },
  components: {
    Button: {
      defaultBg: palette.black3,
      defaultColor: palette.green100,
      defaultBorderColor: palette.green100,
      colorPrimary: palette.green100,
      borderRadius: 6,
      controlHeight: 46,
      fontWeight: 400,
    },
    Input: {
      colorBgContainer: 'transparent',
      activeBorderColor: palette.green100,
      hoverBorderColor: palette.green100,
    },
    Modal: {
      contentBg: palette.black2,
      headerBg: palette.black2,
      titleColor: palette.white100,
    },
    Switch: {
      colorPrimary: palette.green100,
    },
  },
};

export default limitekTheme;
